<div class="ds-icon" [style.height.px]="iconSizeList[size].size">
  <lucide-angular
    class="ds-icon"
    [name]="name"
    [color]="color"
    [size]="iconSizeList[size].size"
    [strokeWidth]="iconSizeList[size].strokeWidth"
    absoluteStrokeWidth="true"
  ></lucide-angular>
</div>
